export { ModalRatePlanVasBlock } from './ValueAddedServices';
export { OrderVasBlock, RentVasBlock } from './ConnectedVasBlocks';
